import { createSelector } from 'reselect';

import getLocationDeliveryEstimates from './getLocationDeliveryEstimates';

import { getEnableMultipleDeliveryEstimate } from './config';

export default createSelector(
  [getLocationDeliveryEstimates, getEnableMultipleDeliveryEstimate],
  (locationDeliveryEstimates, enableMultipleDeliveryEstimate) =>
    !!locationDeliveryEstimates.length && enableMultipleDeliveryEstimate,
);
